(function($){

    var $ = jQuery = $;

    $(document).ready(function() {
        let getParams = 'userId=';
        let url = location.href;
        if (url.indexOf(getParams) > 0) {
            let nickModel = url.split(getParams)[1];
            localStorage.setItem("nickModel",nickModel);
        }

        $('.footer-top__block').each(function(index,value) {
            if($(value).children('.footer-top__block-heading').text().trim() === 'About') {
                let blockContent = $(value).children('.footer-top__block-content');
                $('.footer-bottom__right .social-icons').clone().appendTo(blockContent);
                $(value).find('.social-icons').addClass('social-icons__custom');
                $('.social-icons__custom li').each(function(ind,val) {
                    let name = $(val).attr('class');
                    let link = $(val).children('a');
                    $(link).append(`<span>${name}</span>`);
                });
                let contentLink = $(value).find('.footer-top__block-menu');
                $(contentLink).find('a').each(function(i,v) {
                    if($(v).text().trim() === 'Blog') {
                        $('.footer-bottom__center svg').clone().prependTo(v);
                        $(v).addClass('block-menu__custom_blog');
                        $(v).attr('target','blank');
                    }
                });
                $('.footer-bottom__right .social-icons').css({display:'none'})
            }
        })

        fetch('/cart.js')
        .then(res => res.json())
        .then(out =>
          console.log('Checkout this JSON! ', out))
        .catch(err => { throw err });

        $(document).on('click', '.cart-drawer__checkout, .cart-template__add-to-cart', function (e) {
            e.preventDefault();

            $("body").addClass("fixed");
            $('.cart-popup').removeClass('m-hide');
            $('.cart-popup__bg').removeClass('m-hide');
        });

        $(document).on('click', '.js-cart-popup__btn', function() {
            $('.cart-popup').addClass('m-hide');
            $('.cart-popup__bg').addClass('m-hide');
            function fetchConfig(type = 'json') {
                return {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
                };
              }
            console.log('note');
            const body = JSON.stringify({ note: localStorage.getItem("nickModel") });
            fetch('/cart/update.js', { ...fetchConfig(), ...{ body } })
              .then(res => res.json())
              .then(out => document.location.href = "/checkout")
              .catch(err => { throw err })
        });
    });
})(jQuery);